var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-wrap"},[_c('h1',{staticClass:"card--title text-center mb-1"},[_vm._v(" "+_vm._s(_vm.$t('easy-to-start.card1.title'))+" ")]),_c('h1',{staticClass:"card--text text-center mb-5 mb-sm-8",domProps:{"innerHTML":_vm._s(_vm.$t('easy-to-start.card1.sub-title'))}}),_c('v-img',{staticClass:"mx-auto",attrs:{"width":_vm.userDevice === 'desktop' ? 261 : 235,"height":_vm.language === 'ko'
				? _vm.userDevice === 'desktop'
					? 337
					: 274
				: _vm.userDevice === 'desktop'
				? 303
				: 274,"position":"top center","src":require(("@/assets/images/easily-book-" + _vm.language + ".png"))}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }